
  import createMeisterIcons from '../src/createMeisterIcons';

  const Tree = createMeisterIcons("tree", [["path",{"fill":"currentColor","d":"M6.75 9a5.25 5.25 0 1 1 6 5.197v-.972l2.636-1.582a.75.75 0 0 0-.772-1.286l-1.864 1.119V9a.75.75 0 0 0-1.5 0v1.19l-.72-.72a.75.75 0 1 0-1.06 1.06l1.78 1.78v1.887A5.25 5.25 0 0 1 6.75 9m4.5 6.709a6.751 6.751 0 1 1 1.5 0V21a.75.75 0 0 1-1.5 0z","key":"67fbd8ea435bf007e5fbe82c26889b6096ac788f","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Tree
  